export enum TextTemplateTypeModel {
  ExtendedDescription = 1,
  AddParticipants = 2,
  InfoToParticipants = 3,
  CancelMeeting = 4,
  ChangeMeeting = 5
}